import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Button } from '../components/ui/Button';
const CARD_STYLE: React.CSSProperties = {
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  boxShadow: 'none'
};
const HEADING_FONT = "'RobotoCondensed VariableFont Wght', Roboto Condensed, sans-serif";
// Mock ticket data
const mockTicket = {
  id: '1',
  codice: 'N7G2UFDK',
  titolo: 'Richiesta informazioni rendicontazione',
  stato: 'Aperto',
  priorita: 'Alta',
  tipologia: 'Informazioni/Assistenza',
  argomento: 'Rendicontazione',
  bando: 'Bando 1 - Nuove Opere',
  richiedente: 'Mario Rossi',
  email: 'mario.rossi@example.com',
  assegnatoA: 'Non assegnato',
  dataCreazione: '15/05/2025 10:30',
  ultimoAggiornamento: '15/05/2025 11:45'
};
const mockMessages = [{
  id: 1,
  sender: 'Mario Rossi',
  role: 'user' as const,
  timestamp: '15/05/2025 10:30',
  content: 'Buongiorno, avrei bisogno di chiarimenti riguardo la documentazione necessaria per la fase di rendicontazione del Bando 1. In particolare, le fatture elettroniche devono avere una dicitura specifica?'
}, {
  id: 2,
  sender: 'Admin Sistema',
  role: 'admin' as const,
  timestamp: '15/05/2025 11:45',
  content: 'Buongiorno Mario. Sì, tutte le fatture elettroniche devono riportare il CUP del progetto e la dicitura "Spesa sostenuta a valere sul bando Per Chi Crea 2025". Trova il manuale completo nella sezione FAQ.'
}, {
  id: 3,
  sender: 'Mario Rossi',
  role: 'user' as const,
  timestamp: '15/05/2025 14:20',
  content: "Grazie per la risposta. Un'altra domanda: per le spese di viaggio è sufficiente la ricevuta del biglietto o serve anche una relazione di missione?"
}];
const StatoBadge = ({
  stato
}: {
  stato: string;
}) => {
  const styles: Record<string, React.CSSProperties> = {
    Aperto: {
      backgroundColor: '#e3f2fd',
      color: '#1565c0',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    'In Lavorazione': {
      backgroundColor: '#fff3e0',
      color: '#e65100',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Chiuso: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    }
  };
  return <span style={styles[stato] || styles['Aperto']} data-id="element-1769">{stato}</span>;
};
const PrioritaBadge = ({
  priorita
}: {
  priorita: string;
}) => {
  const styles: Record<string, React.CSSProperties> = {
    Alta: {
      backgroundColor: '#fce4ec',
      color: '#c62828',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Media: {
      backgroundColor: '#fff3e0',
      color: '#e65100',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Bassa: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    }
  };
  return <span style={styles[priorita] || styles['Media']} data-id="element-1770">{priorita}</span>;
};
export function TicketDetail() {
  const {
    id
  } = useParams();
  const [replyText, setReplyText] = useState('');
  const handleUseDraft = () => {
    setReplyText('Gentile Mario, per le spese di viaggio è necessaria sia la ricevuta/biglietto che una relazione di missione firmata dal legale rappresentante. La relazione deve includere: data, destinazione, motivazione e collegamento al progetto finanziato. Trova il modello nella sezione Modulistica del bando.');
  };
  return <div className="space-y-6 pb-12" style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1771">
      {/* Back Link */}
      <div data-id="element-1772">
        <Link to="/ticket/tutti" className="inline-flex items-center gap-2 transition-colors" style={{
        fontSize: '14px',
        color: '#2A97DF',
        fontFamily: 'Roboto, sans-serif',
        textDecoration: 'none'
      }} data-id="element-1773">
          <Icon icon="tabler:arrow-left" fontSize={16} data-id="element-1774" />
          Torna alla lista ticket
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6 items-start" data-id="element-1775">
        {/* Left Column: Main Content */}
        <div className="space-y-6" data-id="element-1776">
          {/* Header Card */}
          <div className="bg-white" style={{
          ...CARD_STYLE,
          padding: '24px 32px'
        }} data-id="element-1777">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1778">
              <div data-id="element-1779">
                <div className="flex items-center gap-3 mb-2" data-id="element-1780">
                  <span style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#80858E',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-1781">
                    Ticket #{mockTicket.codice}
                  </span>
                  <StatoBadge stato={mockTicket.stato} data-id="element-1782" />
                  <PrioritaBadge priorita={mockTicket.priorita} data-id="element-1783" />
                </div>
                <h1 style={{
                fontSize: '24px',
                fontWeight: 400,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                margin: 0
              }} data-id="element-1784">
                  {mockTicket.titolo}
                </h1>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0" data-id="element-1785">
                <Button variant="outlined" className="flex items-center gap-2" data-id="element-1786">
                  <Icon icon="tabler:user-plus" fontSize={16} data-id="element-1787" />
                  Assegna a me
                </Button>
                <Button variant="primary" className="flex items-center gap-2" data-id="element-1788">
                  <Icon icon="tabler:check" fontSize={16} data-id="element-1789" />
                  Segna come Chiuso
                </Button>
              </div>
            </div>
          </div>

          {/* Info Grid */}
          <div className="bg-white" style={CARD_STYLE} data-id="element-1790">
            <div style={{
            padding: '16px 32px',
            borderBottom: '1px solid #E4E4E4'
          }} data-id="element-1791">
              <h2 style={{
              fontSize: '20px',
              fontWeight: 400,
              color: '#293B54',
              fontFamily: HEADING_FONT,
              margin: 0
            }} data-id="element-1792">
                Dettagli Ticket
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" style={{
            padding: '24px 32px'
          }} data-id="element-1793">
              {/* Left Column Details */}
              <div className="space-y-6" data-id="element-1794">
                <div data-id="element-1795">
                  <div className="flex items-center gap-2 mb-2" data-id="element-1796">
                    <Icon icon="tabler:user" fontSize={16} color="#80858E" data-id="element-1797" />
                    <span style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#80858E',
                    fontFamily: HEADING_FONT,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }} data-id="element-1798">
                      Richiedente
                    </span>
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#293B54',
                  fontWeight: 500,
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1799">
                    {mockTicket.richiedente}
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#80858E',
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1800">
                    {mockTicket.email}
                  </div>
                </div>

                <div style={{
                borderTop: '1px solid #F5F5F5',
                paddingTop: '24px'
              }} data-id="element-1801">
                  <div className="flex items-center gap-2 mb-2" data-id="element-1802">
                    <Icon icon="tabler:file-text" fontSize={16} color="#80858E" data-id="element-1803" />
                    <span style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#80858E',
                    fontFamily: HEADING_FONT,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }} data-id="element-1804">
                      Bando
                    </span>
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#293B54',
                  fontWeight: 500,
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1805">
                    {mockTicket.bando}
                  </div>
                </div>

                <div style={{
                borderTop: '1px solid #F5F5F5',
                paddingTop: '24px'
              }} data-id="element-1806">
                  <div className="flex items-center gap-2 mb-2" data-id="element-1807">
                    <Icon icon="tabler:category" fontSize={16} color="#80858E" data-id="element-1808" />
                    <span style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#80858E',
                    fontFamily: HEADING_FONT,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }} data-id="element-1809">
                      Tipologia / Argomento
                    </span>
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#293B54',
                  fontWeight: 500,
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1810">
                    {mockTicket.tipologia}
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#80858E',
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1811">
                    {mockTicket.argomento}
                  </div>
                </div>
              </div>

              {/* Right Column Details */}
              <div className="space-y-6" data-id="element-1812">
                <div className="flex gap-8" data-id="element-1813">
                  <div data-id="element-1814">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1815">
                      <Icon icon="tabler:circle-dot" fontSize={16} color="#80858E" data-id="element-1816" />
                      <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#80858E',
                      fontFamily: HEADING_FONT,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }} data-id="element-1817">
                        Stato
                      </span>
                    </div>
                    <div style={{
                    paddingLeft: '24px'
                  }} data-id="element-1818">
                      <StatoBadge stato={mockTicket.stato} data-id="element-1819" />
                    </div>
                  </div>
                  <div data-id="element-1820">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1821">
                      <Icon icon="tabler:alert-triangle" fontSize={16} color="#80858E" data-id="element-1822" />
                      <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#80858E',
                      fontFamily: HEADING_FONT,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }} data-id="element-1823">
                        Priorità
                      </span>
                    </div>
                    <div style={{
                    paddingLeft: '24px'
                  }} data-id="element-1824">
                      <PrioritaBadge priorita={mockTicket.priorita} data-id="element-1825" />
                    </div>
                  </div>
                </div>

                <div style={{
                borderTop: '1px solid #F5F5F5',
                paddingTop: '24px'
              }} data-id="element-1826">
                  <div className="flex items-center gap-2 mb-2" data-id="element-1827">
                    <Icon icon="tabler:user-check" fontSize={16} color="#80858E" data-id="element-1828" />
                    <span style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#80858E',
                    fontFamily: HEADING_FONT,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }} data-id="element-1829">
                      Assegnato a
                    </span>
                  </div>
                  <div style={{
                  fontSize: '14px',
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  paddingLeft: '24px'
                }} data-id="element-1830">
                    {mockTicket.assegnatoA}
                  </div>
                </div>

                <div style={{
                borderTop: '1px solid #F5F5F5',
                paddingTop: '24px'
              }} className="flex gap-8" data-id="element-1831">
                  <div data-id="element-1832">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1833">
                      <Icon icon="tabler:calendar" fontSize={16} color="#80858E" data-id="element-1834" />
                      <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#80858E',
                      fontFamily: HEADING_FONT,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }} data-id="element-1835">
                        Creato
                      </span>
                    </div>
                    <div style={{
                    fontSize: '14px',
                    color: '#293B54',
                    fontFamily: 'Roboto, sans-serif',
                    paddingLeft: '24px'
                  }} data-id="element-1836">
                      {mockTicket.dataCreazione}
                    </div>
                  </div>
                  <div data-id="element-1837">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1838">
                      <Icon icon="tabler:refresh" fontSize={16} color="#80858E" data-id="element-1839" />
                      <span style={{
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#80858E',
                      fontFamily: HEADING_FONT,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }} data-id="element-1840">
                        Aggiornato
                      </span>
                    </div>
                    <div style={{
                    fontSize: '14px',
                    color: '#293B54',
                    fontFamily: 'Roboto, sans-serif',
                    paddingLeft: '24px'
                  }} data-id="element-1841">
                      {mockTicket.ultimoAggiornamento}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Conversation Thread */}
          <div className="bg-white" style={CARD_STYLE} data-id="element-1842">
            <div style={{
            padding: '16px 32px',
            borderBottom: '1px solid #E4E4E4'
          }} data-id="element-1843">
              <h2 style={{
              fontSize: '20px',
              fontWeight: 400,
              color: '#293B54',
              fontFamily: HEADING_FONT,
              margin: 0
            }} data-id="element-1844">
                Conversazione
              </h2>
            </div>

            {/* Messages */}
            <div style={{
            padding: '24px 32px'
          }} className="space-y-6" data-id="element-1845">
              {mockMessages.map(msg => <div key={msg.id} className={`flex gap-4 ${msg.role === 'admin' ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-1846">
                  {/* Avatar */}
                  <div className="flex-shrink-0 flex items-center justify-center" style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: msg.role === 'admin' ? '#2A97DF' : '#293B54',
                color: 'white',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif',
                fontSize: '16px'
              }} data-id="element-1847">
                    {msg.sender.charAt(0)}
                  </div>
                  {/* Bubble */}
                  <div className={`flex flex-col max-w-[75%] ${msg.role === 'admin' ? 'items-end' : 'items-start'}`} data-id="element-1848">
                    <div className="flex items-center gap-2 mb-1" data-id="element-1849">
                      <span style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1850">
                        {msg.sender}
                      </span>
                      <span style={{
                    fontSize: '12px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1851">
                        {msg.timestamp}
                      </span>
                    </div>
                    <div style={{
                  padding: '14px 18px',
                  fontSize: '14px',
                  fontFamily: 'Roboto, sans-serif',
                  lineHeight: '1.6',
                  borderRadius: msg.role === 'admin' ? '16px 4px 16px 16px' : '4px 16px 16px 16px',
                  backgroundColor: msg.role === 'admin' ? '#D7EDFF' : '#F5F5F5',
                  color: '#444444',
                  border: msg.role === 'admin' ? '1px solid #98C3EC' : '1px solid #E4E4E4'
                }} data-id="element-1852">
                      {msg.content}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* Reply Form */}
            <div style={{
            padding: '24px 32px',
            borderTop: '1px solid #E4E4E4'
          }} data-id="element-1853">
              <textarea rows={4} className="w-full focus:outline-none focus:ring-2 focus:ring-navy-primary/20 focus:border-navy-primary resize-none" placeholder="Scrivi una risposta..." value={replyText} onChange={e => setReplyText(e.target.value)} style={{
              padding: '14px 18px',
              border: '1px solid #E4E4E4',
              borderRadius: '12px',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif',
              color: '#444444'
            }} data-id="element-1854" />
              <div className="flex items-center justify-between mt-4" data-id="element-1855">
                <div className="flex items-center gap-2" style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1856">
                  <Icon icon="tabler:info-circle" fontSize={16} data-id="element-1857" />
                  La risposta sarà visibile al richiedente
                </div>
                <Button variant="primary" className="flex items-center gap-2" disabled={!replyText.trim()} data-id="element-1858">
                  <Icon icon="tabler:send" fontSize={16} data-id="element-1859" />
                  Invia risposta
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: AI Sidebar */}
        <div className="sticky top-[88px] space-y-6" data-id="element-1860">
          <div className="bg-white overflow-hidden" style={CARD_STYLE} data-id="element-1861">
            {/* Sidebar Header */}
            <div style={{
            backgroundColor: '#FFFFFF',
            padding: '16px 20px',
            borderBottom: '1px solid #E4E4E4',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} data-id="element-1862">
              <Icon icon="tabler:sparkles" fontSize={20} color="#293B54" data-id="element-1863" />
              <h2 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#293B54',
              fontFamily: HEADING_FONT,
              margin: 0
            }} data-id="element-1864">
                Assistente AI
              </h2>
            </div>

            <div className="p-5 space-y-6" data-id="element-1865">
              {/* Risposta Suggerita */}
              <div data-id="element-1866">
                <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#80858E',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '8px'
              }} data-id="element-1867">
                  Bozza di risposta
                </div>
                <div style={{
                backgroundColor: 'rgba(215, 237, 255, 0.3)',
                padding: '12px',
                borderRadius: '6px',
                fontSize: '13px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.5,
                marginBottom: '12px',
                border: '1px solid rgba(215, 237, 255, 0.5)'
              }} data-id="element-1868">
                  Gentile Mario, per le spese di viaggio è necessaria sia la
                  ricevuta/biglietto che una relazione di missione firmata dal
                  legale rappresentante. La relazione deve includere: data,
                  destinazione, motivazione e collegamento al progetto
                  finanziato. Trova il modello nella sezione Modulistica del
                  bando.
                </div>
                <div className="flex items-center gap-2" data-id="element-1869">
                  <Button variant="outlined" style={{
                  padding: '6px 12px',
                  fontSize: '12px',
                  flex: 1
                }} onClick={() => navigator.clipboard.writeText('Gentile Mario, per le spese di viaggio è necessaria sia la ricevuta/biglietto che una relazione di missione firmata dal legale rappresentante. La relazione deve includere: data, destinazione, motivazione e collegamento al progetto finanziato. Trova il modello nella sezione Modulistica del bando.')} data-id="element-1870">
                    Copia Risposta
                  </Button>
                  <Button variant="primary" style={{
                  padding: '6px 12px',
                  fontSize: '12px',
                  flex: 1
                }} onClick={handleUseDraft} data-id="element-1871">
                    Usa come bozza
                  </Button>
                </div>
              </div>

              <div style={{
              height: '1px',
              backgroundColor: '#F5F5F5'
            }} data-id="element-1872" />

              {/* Analisi Ticket */}
              <div data-id="element-1873">
                <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#80858E',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '12px'
              }} data-id="element-1874">
                  Analisi
                </div>
                <div className="space-y-3" data-id="element-1875">
                  <div className="flex items-center justify-between" data-id="element-1876">
                    <span style={{
                    fontSize: '13px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1877">
                      Sentiment
                    </span>
                    <div className="flex items-center gap-1.5" data-id="element-1878">
                      <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: '#2A97DF'
                    }} data-id="element-1879" />
                      <span style={{
                      fontSize: '14px',
                      color: '#293B54',
                      fontWeight: 500,
                      fontFamily: 'Roboto, sans-serif'
                    }} data-id="element-1880">
                        Neutro / Informativo
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1881">
                    <span style={{
                    fontSize: '13px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1882">
                      Urgenza stimata
                    </span>
                    <div className="flex items-center gap-1.5" data-id="element-1883">
                      <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: '#E96E00'
                    }} data-id="element-1884" />
                      <span style={{
                      fontSize: '14px',
                      color: '#293B54',
                      fontWeight: 500,
                      fontFamily: 'Roboto, sans-serif'
                    }} data-id="element-1885">
                        Media
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1886">
                    <span style={{
                    fontSize: '13px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1887">
                      Tempo medio risposta
                    </span>
                    <span style={{
                    fontSize: '14px',
                    color: '#293B54',
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-1888">
                      3.5 ore
                    </span>
                  </div>
                </div>
              </div>

              <div style={{
              height: '1px',
              backgroundColor: '#F5F5F5'
            }} data-id="element-1889" />

              {/* FAQ Correlate */}
              <div data-id="element-1890">
                <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#80858E',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '12px'
              }} data-id="element-1891">
                  FAQ Correlate
                </div>
                <div className="space-y-2" data-id="element-1892">
                  {['Documentazione per rendicontazione', 'Spese ammissibili e giustificativi', 'Modelli e template scaricabili'].map((faq, idx) => <a key={idx} href="#" className="flex items-start gap-2 group" style={{
                  textDecoration: 'none'
                }} data-id="element-1893">
                      <Icon icon="tabler:article" fontSize={16} style={{
                    color: '#2A97DF',
                    marginTop: '2px',
                    flexShrink: 0
                  }} data-id="element-1894" />
                      <span style={{
                    fontSize: '13px',
                    color: '#2A97DF',
                    fontFamily: 'Roboto, sans-serif',
                    lineHeight: 1.4
                  }} className="group-hover:underline" data-id="element-1895">
                        {faq}
                      </span>
                    </a>)}
                </div>
              </div>

              <div style={{
              height: '1px',
              backgroundColor: '#F5F5F5'
            }} data-id="element-1896" />

              {/* Ticket Simili */}
              <div data-id="element-1897">
                <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#80858E',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '12px'
              }} data-id="element-1898">
                  Ticket Simili Risolti
                </div>
                <div className="space-y-3" data-id="element-1899">
                  {[{
                  code: 'A3F9KL2M',
                  title: 'Chiarimenti su spese di viaggio',
                  time: '2.1 ore'
                }, {
                  code: 'B7H4TP9Q',
                  title: 'Documentazione rendicontazione fase 2',
                  time: '4.8 ore'
                }].map((ticket, idx) => <div key={idx} style={{
                  border: '1px solid #E4E4E4',
                  borderRadius: '8px',
                  padding: '10px 12px',
                  backgroundColor: '#FFFFFF',
                  boxShadow: 'none'
                }} data-id="element-1900">
                      <div style={{
                    fontSize: '11px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif',
                    marginBottom: '4px'
                  }} data-id="element-1901">
                        Ticket #{ticket.code}
                      </div>
                      <div style={{
                    fontSize: '13px',
                    color: '#293B54',
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif',
                    marginBottom: '6px',
                    lineHeight: 1.3
                  }} data-id="element-1902">
                        {ticket.title}
                      </div>
                      <div style={{
                    fontSize: '11px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }} data-id="element-1903">
                        <Icon icon="tabler:clock-check" fontSize={14} color="#2e7d32" data-id="element-1904" />
                        Risolto in {ticket.time}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}